import { Link, useLocation } from "react-router-dom";
import { Home, Users, Heart, Calendar, UserCheck, MessageCircle } from "lucide-react";

const navItems = [
  { path: "/dashboard", icon: Home, label: "Home" },
  { path: "/discover", icon: Users, label: "Connect" },
  { path: "/messages", icon: MessageCircle, label: "Messages" },
  { path: "/circles", icon: Heart, label: "Circles" },
  { path: "/events", icon: Calendar, label: "Events" },
  { path: "/experts", icon: UserCheck, label: "Experts" },
];

const Navigation = () => {
  const location = useLocation();

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white/95 backdrop-blur-lg border-t border-sage/20 z-50" style={{ paddingBottom: 'env(safe-area-inset-bottom)' }} data-testid="bottom-navigation">
      <div className="max-w-lg mx-auto flex justify-around py-2">
        {navItems.map((item) => {
          const Icon = item.icon;
          const isActive = location.pathname === item.path;
          
          return (
            <Link
              key={item.path}
              to={item.path}
              className={`flex flex-col items-center gap-1 p-2 rounded-xl transition-all duration-300 ${
                isActive 
                  ? 'text-sage-dark' 
                  : 'text-muted-foreground hover:text-sage'
              }`}
              data-testid={`nav-${item.label.toLowerCase()}`}
            >
              <Icon className="w-5 h-5" strokeWidth={isActive ? 2 : 1.5} />
              <span className="text-xs">{item.label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
};

export default Navigation;
